// Components==============
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import { ReceiptEntity } from "typings/Database/Receipt";
// =========================

export const getReceipt = async (userId: number) => {
  const { data } = await axios.get(`/api/receipt/${userId}`);
  return data as ReceiptEntity[];
};

export default function useGetReceiptData(
  userId: number,
  options?: UseQueryOptions
) {
  const query = useQuery({
    queryKey: ["receipt", userId],
    queryFn: () => getReceipt(userId),
    ...options,
  });

  return query;
}
